import * as dedicatedTables from "@/utils/OTR/dedicatedTables";

export default {
  namespaced: true,
  state: {
    dedicatedTables: {
      FREIGHT_DETAILS: dedicatedTables.FREIGHT_DETAILS,
      FREIGHT_DETAILS_SPANISH: dedicatedTables.FREIGHT_DETAILS_SPANISH,
      FREIGHT_DETAILS_TEMPCONTROL: dedicatedTables.FREIGHT_DETAILS_TEMPCONTROL,
      FREIGHT_DETAILS_TEMPCONTROL_SPANISH:
        dedicatedTables.FREIGHT_DETAILS_TEMPCONTROL_SPANISH,
      QUOTE_INFORMATION: dedicatedTables.QUOTE_INFORMATION,
      QUOTE_INFORMATION_SPANISH: dedicatedTables.QUOTE_INFORMATION_SPANISH,
      QUOTE_INFORMATION_PARTIAL: dedicatedTables.QUOTE_INFORMATION_PARTIAL,
      QUOTE_INFORMATION_PARTIAL_SPANISH:
        dedicatedTables.QUOTE_INFORMATION_PARTIAL_SPANISH,
      QUOTE_INFORMATION_TEMPCONTROL_REEFER_FFE_KOOLPAK:
        dedicatedTables.QUOTE_INFORMATION_TEMPCONTROL_REEFER_FFE_KOOLPAK,
      QUOTE_INFORMATION_TEMPCONTROL_REEFER_ROADTEX:
        dedicatedTables.QUOTE_INFORMATION_TEMPCONTROL_REEFER_ROADTEX,
      QUOTE_INFORMATION_TEMPCONTROL_REEFER_CANNON:
        dedicatedTables.QUOTE_INFORMATION_TEMPCONTROL_REEFER_CANNON,
      QUOTE_INFORMATION_TEMPCONTROL_REEFER_SPANISH:
        dedicatedTables.QUOTE_INFORMATION_TEMPCONTROL_REEFER_SPANISH,
      QUOTE_INFORMATION_TEMPCONTROL:
        dedicatedTables.QUOTE_INFORMATION_TEMPCONTROL,
      QUOTE_INFORMATION_TEMPCONTROL_SPANISH:
        dedicatedTables.QUOTE_INFORMATION_TEMPCONTROL_SPANISH
    }
  },
  getters: {
    showDedicatedTables(state) {
      return state.dedicatedTables;
    }
  }
};
